import React from "react";

const WhenTrue = ({ condition, children }) => {
    if (!condition) return null;
    return <>{children}</>;
};

export default WhenTrue;
